<template>
  <div :class="{'bottom-nav-spacing': $vuetify.breakpoint.mdAndDown}">
    <DefaultTemplate v-if="$store.getters['merchant/template'] === 1"/>
    <BoxedTemplate v-if="$store.getters['merchant/template'] === 2"/>
    <BannerLessTemplate v-if="$store.getters['merchant/template'] === 3"/>
    <VinovaTemplate v-if="$store.getters['merchant/template'] === 4"/>
    <VenedorTemplate v-if="$store.getters['merchant/template'] === 5"/>
    <BottomNavigationStore/>
  </div>
</template>

<script>
import DefaultTemplate from "../components/templates/default/DefaultTemplate";
import BoxedTemplate from "../components/templates/boxed/BoxedTemplate";
import BannerLessTemplate from "../components/templates/bannerless/BannerLessTemplate";
import VinovaTemplate from "../components/templates/vinova/VinovaTemplate";
import VenedorTemplate from "../components/templates/venedor/VenedorTemplate";
import BottomNavigationStore from "../components/nav/BottomNavigationStore";
import store from "@/store";

export default {
  name: "Home",
  components: {
    BottomNavigationStore,
    VenedorTemplate,
    BannerLessTemplate,
    BoxedTemplate,
    DefaultTemplate,
    VinovaTemplate
  },
  metaInfo() {
    return {
      title: 'Home'
    }
  },
  created() {
    if (!store.state.catalogue.merchantItems.length) store.dispatch('catalogue/merchantItems');
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (!this.$store.state.global.categories.length) await this.$store.dispatch("global/getHomeData");
    }
  }
}
</script>
